module.exports = __webpack_public_path__ + "static/Lime-afb78795a14cfc2db68a724661b6fb35.svg";